export default __webpack_public_path__ + "static/media/Salvar.5aa5eb95.svg";